import PageNumber from './PageNumber'

export default PageNumber